import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const BusinessDeductionsArticle = lazy(() => import('../pages/articles/business-deductions/page'));
const RetirementStrategiesArticle = lazy(() => import('../pages/articles/retirement-strategies/page'));
const SmallBusinessTipsArticle = lazy(() => import('../pages/articles/small-business-tips/page'));
const EstatePlanningArticle = lazy(() => import('../pages/articles/estate-planning/page'));
const ClientPortalPage = lazy(() => import('../pages/client-portal/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/admin',
    element: <AdminDashboard />,
  },
  {
    path: '/client-portal',
    element: <ClientPortalPage />,
  },
  {
    path: '/articles/business-deductions',
    element: <BusinessDeductionsArticle />,
  },
  {
    path: '/articles/retirement-strategies',
    element: <RetirementStrategiesArticle />,
  },
  {
    path: '/articles/small-business-tips',
    element: <SmallBusinessTipsArticle />,
  },
  {
    path: '/articles/estate-planning',
    element: <EstatePlanningArticle />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
